import { Button } from '@zenterprise-inc/ui';

interface NewPasswordCTAProps {
  disabled: boolean;
}

export const NewPasswordCTA = ({ disabled }: NewPasswordCTAProps) => {
  return (
    <Button.StickyBottom.Wrapper className={'page-padding'}>
      <Button.StickyBottom.Button type={'submit'} state={'primary'} disabled={disabled}>
        다음
      </Button.StickyBottom.Button>
    </Button.StickyBottom.Wrapper>
  );
};
